import { render, staticRenderFns } from "./PaymentRejectModal.vue?vue&type=template&id=1087d6a4"
import script from "./PaymentRejectModal.vue?vue&type=script&lang=js"
export * from "./PaymentRejectModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentRejectModal.vue?vue&type=style&index=0&id=1087d6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports